import Vue from "vue";
import HILabel from "./components/form/HILabel";
import HIInput from "./components/form/HIInput";
import HIRadio from "./components/form/HIRadio";
import HICheckbox from "./components/form/HICheckbox";
import HISelect from "./components/form/HISelect";
import HITextArea from "./components/form/HITextArea";
import HIForm from "./components/form/HIForm";
import Header from "./components/Header";
import Intermediar from "./components/Intermediar";
import ButtonText from "./components/ButtonText";
import ButtonAnswer from "./components/ButtonAnswer";
import Container from "./components/Container";
import ImagePrior from "./components/ImagePrior";
import QuestionWrapper from "./components/QuestionWrapper";

Vue.component("hi-label", HILabel);
Vue.component("hi-input", HIInput);
Vue.component("hi-radio", HIRadio);
Vue.component("hi-checkbox", HICheckbox);
Vue.component("hi-select", HISelect);
Vue.component("hi-form", HIForm);
Vue.component("hi-textarea", HITextArea);
Vue.component("hi-header", Header);
Vue.component("hi-intermediar", Intermediar);
Vue.component("hi-button-text", ButtonText);
Vue.component("hi-button-answer", ButtonAnswer);
Vue.component("hi-container", Container);
Vue.component("hi-image-prior", ImagePrior);
Vue.component("hi-question-wrapper", QuestionWrapper);

//
// SVG COMPONENTS
//
